import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import logo from '../assets/vids/TP_spinning_logo.gif'; // Import the spinning logo GIF
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const { getTotalItems } = useCart();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const cartCount = getTotalItems();

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-content">
          <div className="mobile-header">
            <a 
              href="https://www.instagram.com/travspresents" 
              className="instagram-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram"></i>
            </a>
            
            <div className="toggle-lines" onClick={toggleMenu}>
              <div className={`toggle-line ${isOpen ? 'open' : ''}`}></div>
              <div className={`toggle-line ${isOpen ? 'open' : ''}`}></div>
            </div>
          </div>
          
          <Link to="/" className="navbar-logo">
            <img src={logo} alt="Logo" className="logo-image" />
          </Link>
          
          <ul className={isOpen ? 'nav-menu active' : 'nav-menu'}>
            <li className="nav-item">
              <Link 
                to="/" 
                className={`nav-links ${location.pathname === '/' ? 'active' : ''}`} 
                onClick={toggleMenu}
              >
                HOME
              </Link>
            </li>
            <li className="nav-item">
              <a 
                href="https://www.youtube.com/@travspresents" 
                className="nav-links" 
                onClick={toggleMenu}
                target="_blank"
                rel="noopener noreferrer"
              >
                SET ARCHIVE
              </a>
            </li>
            <li className="nav-item">
              <Link 
                to="/store" 
                className={`nav-links ${location.pathname === '/store' ? 'active' : ''}`} 
                onClick={toggleMenu}
              >
                STORE
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/the-vault" 
                className={`nav-links ${location.pathname === '/the-vault' ? 'active' : ''}`} 
                onClick={toggleMenu}
              >
                THE VAULT
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/contact-us" 
                className={`nav-links ${location.pathname === '/contact-us' ? 'active' : ''}`} 
                onClick={toggleMenu}
              >
                CONTACT US
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/cart" 
                className={`nav-links ${location.pathname === '/cart' ? 'active' : ''}`} 
                onClick={toggleMenu}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" className="cart-icon-inline">
                  <circle cx="9" cy="21" r="1"/>
                  <circle cx="20" cy="21" r="1"/>
                  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
                </svg>
                CART {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 